import { Style } from "types/types";

export const loading: Style = {
  color1: "#FFFFFF",
  color2: "#FFFFFF",
  color3: "#FFFFFF",
  color4: "#FFFFFF",
  color5: "#FFFFFF",
  color6: "#FFFFFF",
  logo: "",
};

export const leanEntries: Style = {
  color1: "#262F3D",
  color2: "#FFFFFF",
  color3: "#9FC130",
  color4: "#2B2A2A",
  color5: "#2B2A2A",
  color6: "#14205E",
  logo: "https://cdn.leanentries.com/Entries_logo_white.png",
};

export const danishLifeScience: Style = {
  color1: "#2e2a82",
  color2: "#FFFFFF",
  color3: "#fb5d50",
  color4: "#595959",
  color5: "#595959",
  color6: "#14205E",
  logo: "https://cdn.leanentries.com/dlc_logo.svg",
};

export default loading;
